import Vue from 'vue'

const url = 'definitions'
const definitions = {
  namespaced: true,
  state: {
    definitions: []
  },
  // CRUD / RESTful actions
  mutations: {
    SET(state, data) {
      state.definitions = data
    },
    NEW(state, data) {
      state.definitions.unshift(data)
    },
    UPD(state, data) {
      const index = state.definitions.findIndex(t => t.id == data.id)
      if(index !== -1) {
        state.definitions.splice(index, 1, data)
      }
    },
    DEL(state, data) {
      state.definitions = state.definitions.filter(res => res.id != data.id)
    }
  },
  actions: {
    async fetch({commit}) {
      const response = await Vue.prototype.$axios.get(url)
      commit('SET', response.data)
    },
    async create({commit}, definition) {
      Vue.prototype.$axios.post(url, definition).then(res => {
        Vue.prototype.$toastr.s('Created new definition.')
        commit('NEW', res.data)
      }).catch(err => {
        console.log(err)
        Vue.prototype.$toastr.e('Could note create definition.')
      })
    },
    async update({commit}, definition) {
      const response = await Vue.prototype.$axios.put(url + '/' + definition.id, definition)
      Vue.prototype.$toastr.s('Updated ' + definition.word)
      commit('UPD', response.data)
    },
    async remove({commit}, definition) {
      const response = await Vue.prototype.$axios.delete(url + '/' + definition.id)
      Vue.prototype.$toastr.s('Deleted Definition Successfully')
      commit('DEL', response.data)
    }
  },
  getters: {
    all: state => state.definitions
  }
}

export default definitions